import React, { Component } from 'react';
import '../../components/Form/form.scss';
import Button from "../../components/Form/Button/Button";
import FieldBuilder from "../../components/Form/FieldBuilder/FieldBuilder";
import { getFieldConfig, validateField } from "../../utils/utils";
import text from '../../utils/text';

interface Props {
    fields: Array<string>;
    handleSubmit: (value: any) => void;
    email: string;
    emailUpdate: boolean;
    handleResetEmail: () => void;
    logged: boolean;
    buttonLabel: string;
}

interface State {
    processing: boolean;
    failed: boolean;
    loading: boolean;
    values: { [key: string]: string };
    errors: { [key: string]: boolean };
    error: string;
}


class UserInformationForm extends Component<Props, State> {

    state: State = {
        loading: true,
        failed: false,
        processing: false,
        values: {},
        errors: {},
        error: ''
    };

    componentDidMount() {

    }

    handleValueChange = (key: string, value: any) => {
        this.setState((state) => ({ values: { ...state.values, [key]: value } }));
    };

    handleSubmit = () => {
        this.setState({error: ''});
        const valid = this.props.fields.map((field) => {
            const isValid = validateField(field, this.state.values[field]);
            this.setState((state) => ({ errors: { ...state.errors, [field]: !isValid } }));
            return isValid;
        });
        const allValid = valid.reduce((accumulator, currentValue) => accumulator = accumulator && currentValue , true);
        if (allValid) {
            this.props.handleSubmit(this.state.values);
        } else {
            this.setState({error: text.mandatory_field});
        }
    };

    render() {
        return (
            <form onSubmit={this.handleSubmit} className='user-information-form' role='user-informations'>

                <p className='user-mail'>
                    {this.props.email}
                    <button onClick={this.props.handleResetEmail}>(modifier)</button>
                </p>

                {Array.from(this.props.fields).map((field) => (
                    <FieldBuilder
                        key={field}
                        hasFailed={this.state.failed}
                        onEnterKey={this.handleSubmit}
                        field={getFieldConfig(field)}
                        value={this.state.values[field] || ''}
                        error={this.state.errors[field] || false}
                        onChange={(value) => {
                            this.handleValueChange(field, value);
                        }}
                    />
                ))}

                {(!this.props.logged || this.props.fields.length > 1) && (
                  <p className='legal'>{text.consent_process_info}</p>
                )}

                { this.state.error && (<p className='error text-red'>{this.state.error}</p>) }

                <Button
                    label={ this.props.buttonLabel }
                    onClick={ () => this.handleSubmit() }
                />


                {(!this.props.logged || this.props.fields.length > 1) && (
                  <p className='legal'>
                      {text.legal_speech}
                      <a
                        href="https://www.editions-tissot.fr/page_contenu/politique-de-protection-des-donnees-personnelles"
                        target="_blank"
                        rel="noreferrer"
                      >
                        Politique de protection des données
                    </a> personnelles.
                  </p>
                )}
                {!this.props.logged && (
                    <p className='legal'>
                        {text.handle_consents}
                        <a
                            href="https://www.editions-tissot.fr/actualite/newsletter/gestion-inscriptions"
                            target="_blank"
                            rel="noreferrer"
                        >
                            sur cette page
                        </a>.
                    </p>
                )}
            </form>

        );
    }
}
export default UserInformationForm;
